// CTA.js

import React, { useRef } from 'react';
import styles from "./CTA.module.scss";
import { motion, useInView } from "framer-motion";

export default function CTA() {
  const firstRef = useRef(null);
  const secondRef = useRef(null);

  const isFirstInView = useInView(firstRef, { once: true, amount: 0.9 });
  const isSecondInView = useInView(secondRef, { once: true, amount: 0.9 });

  return (
    <div className={styles.ctaParent}>
      <h2 ref={firstRef}>
        Performance You Can{" "}
        <motion.span
          className={styles.brushStroke1}
          initial={{ clipPath: 'inset(0 100% 0 0)' }}
          animate={isFirstInView ? { clipPath: 'inset(0 0% 0 0)' } : {}}
          transition={{ duration: .5, ease: 'easeOut' }}
        >
          Measure.
        </motion.span>
      </h2>

      <h2 ref={secondRef}>
        Results You Can{" "}
        <motion.span
          className={styles.brushStroke2}
          initial={{ clipPath: 'inset(0 100% 0 0)' }}
          animate={isSecondInView ? { clipPath: 'inset(0 0% 0 0)' } : {}}
          transition={{ duration: .5, ease: 'easeOut', delay: .5 }}
        >
          Trust.
        </motion.span>
      </h2>
    </div>
  );
}
